module.exports = __webpack_public_path__ + "img/Dantam Bridal 24.0bf78d87.jpg";